import { ESymbolType } from '@webtrader/core/api/market/symbols';
import i18n from '@webtrader/core/i18n';

export enum ESignalFilter {
  ALL = 'ALL',
  FAVOURITE = 'FAVOURITE'
}

export const SIGNAL_CATEGORY_FILTERS = [
  {
    key: ESymbolType.CRYPTO,
    label: () => i18n.t('Cryptocurrency')
  },
  {
    key: ESymbolType.FOREX,
    label: () => i18n.t('Forex')
  },
  {
    key: ESymbolType.SHARES,
    label: () => i18n.t('Shares')
  },
  {
    key: ESymbolType.INDEX,
    label: () => i18n.t('Index')
  },
  {
    key: ESymbolType.COMMODITIES,
    label: () => i18n.t('Commodities')
  }
];
